module.exports = "::ng-deep .page-titles {\r\n  background: #f4f6f9;\r\n  margin-top: 70px;\r\n  padding: 0px;\r\n  margin-left: 240px;\r\n  padding-top: 7px;\r\n  height: 40px;\r\n  -webkit-box-shadow: 1px 1px 3px #cccccc;\r\n          box-shadow: 1px 1px 3px #cccccc;\r\n}\r\n\r\n::ng-deep .text-headerbar {\r\n  padding-top: 10px;\r\n  color: #212529;\r\n}\r\n\r\n/* ::ng-deep .text-headerbar:hover {\r\n    color: #757575;\r\n} */\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/headerbar/headerbar.component.css
// module id = ./src/app/components/headerbar/headerbar.component.css
// module chunks = main